import { Language } from '~/hooks/useCurrentLang';

import { SitePageNode } from './models';

const findCurrentLanguageUrl = (
  currentLangCode: string,
  languages: Language[]
): string => {
  const foundLanguage = languages.find(
    (language) => language.locale === currentLangCode
  );

  return foundLanguage?.url ?? '/';
};

export const isPageNotFound = (
  currentPage: SitePageNode | null,
  pathname: string
): boolean => currentPage === null || pathname.includes('/404/');

export const resolveNotFoundPageUrl = (
  targetLangUrl: string,
  currentLangCode: string,
  languages: Language[],
  pathname: string
): string => {
  const currentLangUrl = findCurrentLanguageUrl(currentLangCode, languages);
  const cleanPathname = pathname.replace(currentLangUrl, '');

  return targetLangUrl + cleanPathname;
};
